import {createRoute} from '@/velta/components/crud';
import {createRoute as createRouteFilter} from '@/velta/components/filter';
import routesImportador from "@/router/importadorRoutes";

// Definimos as rotas da empresa

const routes = [
    {
        path: "/sistema/empresa/excluir-conta",
        name: "excluir-conta",
        component: () => import("@/views/empresa/ExcluirConta.vue"),
        meta: {
            resource: "auth",
            layout: "full",
            pageTitle: "Excluir a minha conta",
        },
    },
    {
        path: "/sistema/empresa/login-geral",
        name: "login-geral",
        component: () => import("@/views/empresa/LoginGeral.vue"),
        meta: {
            resource: "auth",
            layout: "full",
            pageTitle: "Acessar Sistema",
        },
    },
    {
        path: "/sistema/empresa/parceiros-veltacar",
        name: "parceiros-veltacar",
        component: () => import("@/views/empresa/ParceirosVeltaCar.vue"),
        meta: {
            pageTitle: "Parceiros VeltaCar",
            resource: "any",
            breadcrumb: [
                {
                    text: "Parceiros VeltaCar",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta",
        name: "adminvelta",
        component: () => import("@/views/empresa/AdminVelta.vue"),
        meta: {
            pageTitle: "Admin Velta",
            resource: "ADMINVELTA",
            action: "read",
        },
    },
    {
        path: "/sistema/empresa/adminvelta/nps-insights",
        name: "adminvelta-nps-insights",
        component: () => import("@/views/admin/NPSInsights.vue"),
        meta: {
            pageTitle: "Dashboard NPS",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                {
                    text: "Admin Velta",
                    to: { name: "adminvelta" },
                },
                {
                    text: "Dashboard NPS",
                    active: true,
                },
            ],
        },
    },
    // CRM Routes
    {
        path: "/sistema/empresa/adminvelta/crm",
        name: "adminvelta-crm",
        component: () => import("@/views/empresa/adminveltacrm/Dashboard.vue"),
        meta: {
            pageTitle: "CRM",
            resource: "ADMINVELTA",
            action: "read",
            navActiveLink: "adminvelta-crm",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "CRM", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/crm/entidades/:id",
        name: "adminvelta-crm-entidade-detail",
        component: () => import("@/views/empresa/adminveltacrm/EntidadeDetail.vue"),
        meta: {
            pageTitle: "Detalhe da Entidade",
            resource: "ADMINVELTA",
            action: "read",
            navActiveLink: "adminvelta-crm",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "CRM", to: { name: "adminvelta-crm" } },
                { text: "Detalhe", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/crm/kanban",
        name: "adminvelta-crm-kanban",
        component: () => import("@/views/empresa/adminveltacrm/KanbanView.vue"),
        meta: {
            pageTitle: "Kanban - Jornada do Cliente",
            resource: "ADMINVELTA",
            action: "read",
            navActiveLink: "adminvelta-crm",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "CRM", to: { name: "adminvelta-crm" } },
                { text: "Kanban", active: true },
            ],
        },
    },
    // Disparo em Massa de WhatsApp
    {
        path: "/sistema/empresa/adminvelta/disparo-massa",
        name: "adminvelta-disparo-massa",
        component: () => import("@/views/empresa/adminveltadisparomassa/Index.vue"),
        meta: {
            pageTitle: "Disparo em Massa",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Disparo em Massa", active: true },
            ],
        },
    },
    // NFS-e de Cobranças
    {
        path: "/sistema/empresa/adminvelta/nfse-cobrancas",
        name: "adminvelta-nfse-cobrancas",
        component: () => import("@/views/empresa/adminveltanfse/NfseCobrancasList.vue"),
        meta: {
            pageTitle: "NFS-e de Cobranças",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "NFS-e de Cobranças", active: true },
            ],
        },
    },
    // Replicação de Dados Entre Filiais
    {
        path: "/sistema/empresa/adminvelta/replicacao",
        name: "adminvelta-replicacao",
        component: () => import("@/views/empresa/adminveltareplicacao/Index.vue"),
        meta: {
            pageTitle: "Replicação Filiais",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Replicação Filiais", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/replicacao/nova",
        name: "adminvelta-replicacao-form",
        component: () => import("@/views/empresa/adminveltareplicacao/Form.vue"),
        meta: {
            pageTitle: "Nova Replicação",
            resource: "ADMINVELTA",
            action: "create",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Replicação Filiais", to: { name: "adminvelta-replicacao" } },
                { text: "Nova", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/replicacao/execucoes/:id",
        name: "adminvelta-replicacao-execucao",
        component: () => import("@/views/empresa/adminveltareplicacao/ExecucaoDetail.vue"),
        meta: {
            pageTitle: "Execução",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                { text: "Admin Velta", to: { name: "adminvelta" } },
                { text: "Replicação Filiais", to: { name: "adminvelta-replicacao" } },
                { text: "Execução", active: true },
            ],
        },
    },
    {
        path: "/sistema/empresa/",
        name: "home-company",
        component: () => import("@/views/empresa/Home.vue"),
        meta: {
            pageTitle: "Página Inicial",
            resource: "any",
            breadcrumb: [
                {
                    text: "Página Inicial",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/dashboardfinanceiro",
        name: "dashboardfinanceiro",
        component: () => import("@/views/empresa/DashboardFinanceiro.vue"),
        meta: {
            pageTitle: "Dashboard Financeiro",
            resource: "DASH_FINANCEIRO",
            action: "read",
            breadcrumb: [
                {
                    text: "Dashboard Financeiro",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/dashboardservicos",
        name: "dashboardservicos",
        component: () => import("@/views/empresa/DashboardServicos.vue"),
        meta: {
            pageTitle: "Dashboard Serviços",
            resource: "DASH_SERVICOS",
            action: "read",
            breadcrumb: [
                {
                    text: "Dashboard Serviços",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/painel-tv",
        name: "painel-tv",
        component: () => import("@/views/empresa/painelTv/Index.vue"),
        meta: {
            pageTitle: "Painel TV",
            resource: "TAR_ORDENSDESERVICO",
            action: "read",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/cadastroempresa",
        name: "cadastroempresa",
        component: () =>
            import("@/views/empresa/cadastroEmpresa/CadastroEmpresa.vue"),
        meta: {
            pageTitle: "Cadastrar Empresa",
            resource: "auth",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/buscador/:estado?/:cidade?/:servico?",
        name: "buscador",
        component: () => import("@/views/empresa/buscador/Index.vue"),
        meta: {
            pageTitle: "Buscador de Empresa",
            resource: "auth",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/configuracoes",
        name: "configuracoes-company",
        component: () => import("@/views/empresa/configuracoes/Form.vue"),
        meta: {
            resource: "CAD_CONFIGURACOES",
            action: "read",
        },
    },
    {
        path: "/sistema/empresa/login",
        name: "login-company",
        component: () => import("@/views/empresa/Login.vue"),
        meta: {
            pageTitle: "Acessar Sistema",
            resource: "auth",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/esqueciminhasenha",
        name: "esqueciminhasenha-company",
        component: () => import("@/views/empresa/ForgotPassword.vue"),
        meta: {
            resource: "auth",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/termodeuso",
        name: "termodeuso",
        component: () => import("@/views/empresa/TermoDeUso.vue"),
        meta: {
            resource: "auth",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/politicaprivacidade",
        name: "politicaprivacidade",
        component: () =>
            import("@/views/empresa/PoliticaDePrivacidadeDeDados.vue"),
        meta: {
            resource: "auth",
            layout: "full",
        },
    },
    {
        path: "/sistema/empresa/nao-autorizado",
        name: "naoAutorizado",
        component: () => import("@/views/empresa/NaoAutorizado.vue"),
        meta: {
            layout: "full",
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/plano-bloqueado",
        name: "planoBloqueado",
        component: () => import("@/views/empresa/PlanoBloqueado.vue"),
        meta: {
            layout: "full",
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/error-404",
        name: "error-404",
        component: () => import("@/views/empresa/error/Error404.vue"),
        meta: {
            layout: "full",
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/planosepagamentos",
        name: "planosepagamentos",
        component: () => import("@/views/empresa/planosepagamentos/List.vue"),
        meta: {
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/planosepagamentos/cartao",
        name: "planosepagamentos-cartao",
        component: () => import("@/views/empresa/planosepagamentos/Cartao.vue"),
        meta: {
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/faq",
        name: "faq",
        component: () => import("@/views/empresa/faq/Index.vue"),
        meta: {
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/indicacao",
        name: "indicacao",
        component: () => import("@/views/empresa/indicacao/Index.vue"),
        meta: {
            pageTitle: "Indicação",
            resource: "any",
            breadcrumb: [
                {
                    text: "Indicação",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/adminvelta/indicacoes",
        name: "adminvelta-indicacoes",
        component: () =>
            import("@/views/empresa/adminveltaindicacoes/Index.vue"),
        meta: {
            pageTitle: "Gestão de Indicações",
            resource: "ADMINVELTA",
            action: "read",
            breadcrumb: [
                {
                    text: "Admin Velta",
                    to: { name: "adminvelta" },
                },
                {
                    text: "Gestão de Indicações",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/ordemservico",
        name: "ordemservico",
        component: () => import("@/views/empresa/ordemservico/Index.vue"),
        meta: {
            resource: "TAR_ORDENSDESERVICO",
            action: "read",
            navActiveLink: "ordemservico",
        },
    },
    {
        path: "/sistema/empresa/estoque/dashboard",
        name: "estoquedashboard",
        component: () => import("@/views/empresa/estoque/Dash.vue"),
        meta: {
            resource: "CAD_ESTOQUE",
            action: "read",
            navActiveLink: "estoque",
        },
    },
    {
        path: "/sistema/empresa/consumo-fracionado",
        name: "consumofracionado",
        component: () => import("@/views/empresa/consumofracionado/Dashboard.vue"),
        meta: {
            resource: "CAD_ESTOQUE",
            action: "read",
            pageTitle: "Consumo Fracionado",
            navActiveLink: "estoque",
        },
    },
    {
        path: "/sistema/empresa/configuracoes-iniciais",
        name: "initialConfiguration",
        component: () =>
            import("@/views/empresa/configuracoesIniciais/Index.vue"),
        meta: {
            pageTitle: "Configurações Iniciais",
            resource: "any",
            breadcrumb: [
                {
                    text: "Configurações Iniciais",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/onboarding",
        name: "onboarding",
        component: () => import("@/views/empresa/onboarding/Index.vue"),
        meta: {
            layout: "onboarding",
            resource: "any",
        },
    },
    {
        path: "/sistema/empresa/whatsapp-suporte",
        name: "initialConfigurationWhatsappSuporte",
        component: () =>
            import("@/views/empresa/configuracoesIniciais/WhatsAppSuporte.vue"),
        meta: {
            pageTitle: "Configurações Iniciais",
            resource: "any",
            breadcrumb: [
                {
                    text: "Configurações Iniciais",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/black-veltacar",
        name: "blackPromotion",
        component: () => import("@/views/empresa/promotion/Black.vue"),
        meta: {
            pageTitle: "BlackVeltacar",
            resource: "any",
            breadcrumb: [
                {
                    text: "BlackVeltacar",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/versions",
        name: "versions",
        component: () => import("@/views/empresa/Versions.vue"),
        meta: {
            pageTitle: "Histórico de Versões",
            resource: "any",
            breadcrumb: [
                {
                    text: "Histórico de Versões",
                    active: true,
                },
            ],
        },
    },
    ...routesImportador,
    ...createRoute("Empresas", "adminveltaempresas", "ADMINVELTA"),
    ...createRoute("Usuários Auto-Agendamento", "adminveltaclientesgerais", "ADMINVELTA"),
    ...createRoute("Planos", "adminveltaplanos", "ADMINVELTA"),
    ...createRoute("Blog", "adminveltaposts", "ADMINVELTA"),
    ...createRoute("Notificacoes", "adminveltanotificacoes", "ADMINVELTA"),
    ...createRoute("Vídeo Aulas", "adminveltavideoaulas", "ADMINVELTA"),
    ...createRoute("Usuários", "usuario", "CAD_USUARIOS"),
    ...createRoute(
        "Modalidade de Entrega",
        "modalidade",
        "CAD_MODALIDADES",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Controle de Caixa",
        "controlecaixa",
        "TAR_CONTROLECAIXA",
        "Operacionais",
        true,
        true
    ),
    ...createRoute(
        "Serviços",
        "servico",
        "CAD_SERVICOS",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Categorias de Serviço",
        "categoria-servico",
        "CAD_SERVICOS",
        "Cadastros",
        false,
        false
    ),
    ...createRoute("Perfis", "perfil", "CAD_PERFIS"),
    ...createRoute("Vagas", "vaga", "CAD_VAGAS", "Cadastros", true, true),
    ...createRoute(
        "Orçamentos",
        "orcamento",
        "TAR_ORCAMENTOS",
        "Operacionais",
        true,
        true
    ),
    ...createRoute("Recibos", "recibo", "TAR_RECIBOS"),
    ...createRoute(
        "Sugestão de Melhoria",
        "sugestaomelhoria",
        "CAD_SUGESTAOMELHORIA"
    ),
    ...createRoute("Clientes", "cliente", "CAD_CLIENTES"),
    ...createRoute(
        "Nota Fiscal",
        "notafiscal",
        "TAR_NOTAFISCAL",
        "Operacionais"
    ),
    ...createRoute(
        "Convênios",
        "convenio",
        "CAD_CONVENIOS",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Comissões",
        "comissao",
        "CAD_COMISSAO",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Funcionários",
        "funcionario",
        "CAD_FUNCIONARIOS",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Profissões",
        "profissao",
        "CAD_PROFISSOES",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Produtos/Peças",
        "produto",
        "CAD_PRODUTOS",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Grupos de Estoque",
        "grupoestoque",
        "CONF_ESTOQUEINDIVIDUALIZADOPORCONCESSIONARIAS",
        "Cadastros",
        true,
        true
    ),
    ...createRoute(
        "Venda de Produtos/Peças",
        "venda",
        "CAD_VENDAPRODUTOS",
        "Operacionais"
    ),
    ...createRoute(
        "Entradas Estoque",
        "estoque",
        "CAD_ESTOQUE",
        "Operacionais"
    ),
    ...createRoute("NFe Entrada", "nfeentrada", "NFE_ENTRADA", "Operacionais"),
    ...createRoute("Fornecedores", "fornecedor", "CAD_FORNECEDOR", "Cadastros"),
    ...createRoute(
        "Empresa Cliente",
        "empresaCliente",
        "CONF_MODELO_CONCESSIONARIA|CONF_AUTOAGENDAMENTOPREENCHEREMPRESA",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Formas de Pagamento",
        "formasdepagamentos",
        "CAD_FORMASDEPAGAMENTOS",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Maquininhas de Cartão",
        "maquininha",
        "CAD_MAQUININHAS",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Checklist Modelo",
        "itemchecklistmodelo",
        "CAD_ITEM_MODELO_CHECKLIST",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Categorias de Caixa",
        "controlecaixacategoria",
        "CAD_CONTROLE_CAIXA_CATEGORIA",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Programa de Fidelidade",
        "programafidelidade",
        "CAD_FIDELIDADE",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Recompensas Fidelidade",
        "recompensafidelidade",
        "CAD_FIDELIDADE",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Categorias de Patrimônio",
        "patrimonio-categoria",
        "CAD_PATRIMONIO",
        "Cadastros",
        false,
        false
    ),
    ...createRoute(
        "Patrimônio",
        "patrimonio",
        "CAD_PATRIMONIO",
        "Cadastros",
        false,
        false
    ),
    ...createRouteFilter("Estoque", "RelatorioEstoque", "REL_ESTOQUE"),
    ...createRouteFilter("Produtos a Vencer", "ProdutosAVencer", "REL_ESTOQUE"),
    ...createRouteFilter(
        "Relatório de Venda de Produtos/Peças",
        "RelatorioVenda",
        "REL_VENDA"
    ),
    ...createRouteFilter("Clientes", "RelatorioCliente", "CAD_CLIENTES"),
    ...createRouteFilter("Caixa", "Caixa", "REL_CAIXA"),
    ...createRouteFilter("Contas a Pagar", "ContasAPagar", "REL_CONTASAPAGAR"),
    ...createRouteFilter(
        "Aniversariantes",
        "Aniversariante",
        "REL_ANIVERSARIANTES"
    ),
    ...createRouteFilter(
        "Serviços Realizados",
        "ServicoRealizado",
        "REL_SERVICOSREALIZADOS"
    ),
    ...createRouteFilter(
        "Serviços Pos-Venda Clientes",
        "ServicoPosVendaCliente",
        "REL_SERVICOSPOSVENDACLIENTES"
    ),
    ...createRouteFilter(
        "Comissões",
        "RelatorioComissao",
        "REL_COMISSAO"
    ),
    ...createRouteFilter("Patrimônio", "RelatorioPatrimonio", "REL_PATRIMONIO"),

    // Integrações e Automações
    {
        path: "/sistema/empresa/integracoes",
        name: "integracoes",
        component: () => import("@/views/empresa/integracoes/Index.vue"),
        meta: {
            pageTitle: "Integrações",
            resource: "INT_INTEGRACOES",
            action: "read",
            breadcrumb: [
                {
                    text: "Integrações",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/automacoes",
        name: "automacao",
        component: () =>
            import("@/views/empresa/integracoes/automacoes/List.vue"),
        meta: {
            pageTitle: "Automações",
            navActiveLink: "automacao",
            resource: "INT_AUTOMACOES",
            action: "read",
            breadcrumb: [
                {
                    text: "Integrações",
                    to: { name: "integracoes" },
                },
                {
                    text: "Automações",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/automacoes/c",
        name: "automacaoCreate",
        component: () =>
            import("@/views/empresa/integracoes/automacoes/Form.vue"),
        meta: {
            pageTitle: "Nova Automação",
            navActiveLink: "automacao",
            resource: "INT_AUTOMACOES",
            action: "create",
            breadcrumb: [
                {
                    text: "Integrações",
                    to: { name: "integracoes" },
                },
                {
                    text: "Automações",
                    to: { name: "automacao" },
                },
                {
                    text: "Nova Automação",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/automacoes/r/:id",
        name: "automacaoRead",
        component: () =>
            import("@/views/empresa/integracoes/automacoes/Form.vue"),
        meta: {
            pageTitle: "Visualizar Automação",
            navActiveLink: "automacao",
            resource: "INT_AUTOMACOES",
            action: "read",
            breadcrumb: [
                {
                    text: "Integrações",
                    to: { name: "integracoes" },
                },
                {
                    text: "Automações",
                    to: { name: "automacao" },
                },
                {
                    text: "Visualizar Automação",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/automacoes/u/:id",
        name: "automacaoUpdate",
        component: () =>
            import("@/views/empresa/integracoes/automacoes/Form.vue"),
        meta: {
            pageTitle: "Editar Automação",
            navActiveLink: "automacao",
            resource: "INT_AUTOMACOES",
            action: "update",
            breadcrumb: [
                {
                    text: "Integrações",
                    to: { name: "integracoes" },
                },
                {
                    text: "Automações",
                    to: { name: "automacao" },
                },
                {
                    text: "Editar Automação",
                    active: true,
                },
            ],
        },
    },
    {
        path: "/sistema/empresa/automacoes/:id/logs",
        name: "automacaoLogs",
        component: () =>
            import("@/views/empresa/integracoes/automacoes/Logs.vue"),
        meta: {
            pageTitle: "Histórico de Envios",
            navActiveLink: "automacao",
            resource: "INT_AUTOMACOES",
            action: "read",
            breadcrumb: [
                {
                    text: "Integrações",
                    to: { name: "integracoes" },
                },
                {
                    text: "Automações",
                    to: { name: "automacao" },
                },
                {
                    text: "Histórico de Envios",
                    active: true,
                },
            ],
        },
    },
];

export default routes;
